import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { PROTECTED_API_URL } from '@lib/core/tokens/api.tokens';

import { AchiCodeItem, DictionarySearchPayload, DictionaryType, DrugItem, Icd10CodeItem, Icpc2CodeItem, LaboratoryCodeItem } from '../models/dictionary.model';
import { ContinuationPage } from '../models/protocol-search.model';

const DICTIONARY_PATH: Record<DictionaryType, string> = {
  icd10: 'icd10',
  icpc2: 'icpc2',
  achi: 'achi',
  drug: 'drugs',
  laboratory: 'laboratory',
};

const DEFAULT_PAGE_SIZE = 20;

@Injectable({ providedIn: 'root' })
export class ProtocolDictionariesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl: string;

  constructor(@Inject(PROTECTED_API_URL) apiUrl: string) {
    this.baseUrl = `${apiUrl}/dictionaries`;
  }

  searchIcd10(payload: DictionarySearchPayload): Observable<ContinuationPage<Icd10CodeItem>> {
    return this.search<Icd10CodeItem>('icd10', payload);
  }

  searchIcpc2(payload: DictionarySearchPayload): Observable<ContinuationPage<Icpc2CodeItem>> {
    return this.search<Icpc2CodeItem>('icpc2', payload);
  }

  searchAchi(payload: DictionarySearchPayload): Observable<ContinuationPage<AchiCodeItem>> {
    return this.search<AchiCodeItem>('achi', payload);
  }

  searchDrugs(payload: DictionarySearchPayload): Observable<ContinuationPage<DrugItem>> {
    return this.search<DrugItem>('drug', payload);
  }

  searchLaboratory(payload: DictionarySearchPayload): Observable<ContinuationPage<LaboratoryCodeItem>> {
    return this.search<LaboratoryCodeItem>('laboratory', payload);
  }

  search<T>(type: DictionaryType, payload: DictionarySearchPayload): Observable<ContinuationPage<T>> {
    return this.http.post<ContinuationPage<T>>(`${this.baseUrl}/${DICTIONARY_PATH[type]}/search`, {
      pageSize: DEFAULT_PAGE_SIZE,
      ...payload,
    });
  }
}
